import React from 'react';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  labelTxtColorCARD: {
    color: 'black !important',
    fontSize: '1.17rem !important',
    fontWeight: 'bold',
  },
  labelTxtColorField: {
    color: 'black !important',
  },
  dense: {
    marginTop: '20px !important',
  },
  menu: {
    width: 200,
  },
});

const PaddingBottom = {
  paddingBottom: '0.75rem',
};

class CETicketTextFiled extends React.Component {
  state = {};
  render() {
    const {
      classes,
      trigerHandleChange,
      trigerOnBlur,
      stateValue,
      labelText,
      stateName,
      forField,
      disabled,
      id,
    } = this.props;
    return (
      <Grid item xs={12} style={PaddingBottom}>
        <form className={classes.container} noValidate autoComplete="off">
          <TextField
            disabled={disabled}
            fullWidth
            InputLabelProps={{
              className: forField
                ? classes.labelTxtColorField
                : classes.labelTxtColorCARD,
              shrink: true,
            }}
            inputProps={
              disabled ? {} : { 'data-custome-value-id': id.toString() }
            }
            label={labelText}
            multiline
            defaultValue={stateValue}
            onChange={trigerHandleChange}
            onBlur={trigerOnBlur}
            variant="outlined"
            className={forField ? classNames(classes.dense) : null}
          />
        </form>
      </Grid>
    );
  }
}

CETicketTextFiled.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CETicketTextFiled);
